import { Box, BoxForListing } from 'entities/Box';

export interface BoxFormDrawerSchema {
  mode: Nullable<DrawerMode>;
  box?: Nullable<BoxForListing | Box>;
}

export enum DrawerMode {
  BOX_EDIT = 'box_edit',
  BOX_CREATE = 'box_create',
}
